import format from 'date-fns/format';
import { EMPTY_COUNTRY, EMPTY_REGION } from '@front-app/components/inputs/CountryPickerData';
import { Address } from '@front-app/services/SharedModels';
import { Nullable } from './types';

export const toDigits = (str: string | number): string => (`${str}`).replace(/\D/g, '');

export function formatAddress(address: Nullable<Address>): Address {
	let regionCode = address.provStateRegion;
	if (!address.country && regionCode) {
		regionCode = EMPTY_REGION;
	}

	return {
		street1: address.street1?.trim() || '',
		street2: address.street2?.trim() || '',
		city: address.city?.trim() || '',
		provStateRegion: regionCode || EMPTY_REGION,
		country: address.country || EMPTY_COUNTRY,
		postalCode: address.postalCode?.trim() || '',
	};
}

export const formatPhoneNumber = (str: string | number): string => {
	// Filter only numbers from the input
	const cleaned = toDigits(str);

	if (cleaned.length === 11) {
		// Check if the input is of correct length
		const match = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{4})$/);

		if (match) {
			return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
		}
	} else {
		// Check if the input is of correct length
		const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

		if (match) {
			return `(${match[1]}) ${match[2]}-${match[3]}`;
		}
	}

	return cleaned;
};

export const toDatetimeLocal = (date: Date | number | string): string => {
	if (typeof date === 'string') {
		return toDatetimeLocal(new Date(date));
	}
	return format(date, "yyyy-MM-dd'T'HH:mm");
};

export const toZonedDatetimeLocal = (date: Date | number | string | undefined | null): string | null | undefined => {
	if (!date && typeof date !== 'number') {
		return date;
	}
	return new Date(date).toISOString();
};
